import Draw from 'ol/interaction/Draw.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import {BingMaps,OSM, Source, Vector as VectorSource} from 'ol/source.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import KML from 'ol/format/KML.js';
import proj4 from 'proj4';
import LayerGroup from 'ol/layer/Group';
import Feature from 'ol/Feature.js';
import Geolocation from 'ol/Geolocation.js';
import Point from 'ol/geom/Point.js';
import {Circle as CircleStyle, Fill, Stroke,Icon, Style} from 'ol/style.js';
//import {style}  from 'ol/styles.js';{Icon, Style}
import Control from 'ol/control/Control';
import {circular} from 'ol/geom/Polygon';
import { LineString } from 'ol/geom';
import { WKT} from 'ol/format.js';

//expandmenu
var count=0
document.getElementById('expandbtn').addEventListener('click',function(){
  count++
  var xx=(count%2);
 if (xx===0){
     document.getElementById('expandbtn').src='./menu.png';
 // document.getElementById('mouseposition1').style.display="block";
     document.getElementById('toolsbackgeround').style.display="none";
     document.getElementById('map').style.width="100%";
     document.getElementById('menu').style.right='1px';
  }
    
    else
  {
  document.getElementById('toolsbackgeround').style.display='block';
  document.getElementById('expandbtn').src='./unmenu.png' ;
    if (screen.width<650){
     document.getElementById('map').style.width="65%";
    document.getElementById('toolsbackgeround').style.width="35%";
    var xwidth=(screen.width-(((screen.width)*65)/100))+5;
    var strwidth=xwidth+'px';
     document.getElementById('menu').style.right=strwidth;
     }
    else{
    document.getElementById('map').style.width="75%";
    document.getElementById('toolsbackgeround').style.width="25%";
    var xwidth=(screen.width-(((screen.width)*75)/100))+1;
    var strwidth=xwidth+'px';
    document.getElementById('menu').style.right=strwidth;
  }
  }

});

const raster = new TileLayer({
  source: new BingMaps({
    key: 'Ak_BhUnNAigKZkF64lHRFwDeBR8KZpEeokYgA3cTNHmOu8i0_dHO9AByeRhLWpQV',
    imagerySet: 'AerialWithLabelsOnDemand',
})
});

const source = new VectorSource({wrapX: false});

const vector = new VectorLayer({
  source: source,
 });

const map = new Map({
  layers: [raster, vector],
  target: 'map',
  view: new View({
    projection:'EPSG:4326',
    center: [52.10,32.30],
    zoom: 4,
  }),
});
const styles = {
  Point: {
    'circle-radius': 5,
    'circle-fill-color': 'red',
  },
  LineString: {
    'circle-radius': 5,
    'circle-fill-color': 'red',
    'stroke-color': 'yellow',
    'stroke-width': 2,
  },
  Polygon: {
    'circle-radius': 5,
    'circle-fill-color': 'red',
    'stroke-color': 'yellow',
    'stroke-width': 2,
    'fill-color': 'blue',
    'fill-color-opacity':'0.3',
    'fill-opacity':'.6',
    },
  Circle: {
    'circle-radius': 5,
    'circle-fill-color': 'red',
    'stroke-color': 'blue',
    'stroke-width': 2,
    'fill-color': 'yellow',
    'opacity':'60%'
  },
};

const typeSelect = document.getElementById('type');

let draw; // global so we can remove it later


const typeselect2=document.getElementsByClassName('draw');
const value2=typeselect2.value;


 const draw2=new Draw({
  source:source,
  type:'Point',
  style:styles['Point.Value'],
});
const draw3=new Draw({
  source:source,
  type:'LineString',
  style:styles[value2],
});
const draw4=new Draw({
  source:source,
  type:'Polygon',
  style:styles[value2],
});

document.getElementById('drawpnt').addEventListener('click',function(){
 if (draw3!=='none'||draw4!='none'){
  map.removeInteraction(draw3);
  map.removeInteraction(draw4);
 };
 
  

  
  map.addInteraction(draw2);
  
  document.getElementById('drawpnt').style.backgroundColor='yellow';
  document.getElementById('drawline').style.backgroundColor='rgb(234, 231, 231)';
  document.getElementById('drawplgn').style.backgroundColor='rgb(234, 231, 231)';

});

document.getElementById('drawline').addEventListener('click',function(){
  if (draw2!=='none'||draw4!='none'){
    map.removeInteraction(draw2);
    map.removeInteraction(draw4);
   };
  
    map.addInteraction(draw3);
    document.getElementById('drawpnt').style.backgroundColor='rgb(234, 231, 231)';
    document.getElementById('drawline').style.backgroundColor='yellow';
    document.getElementById('drawplgn').style.backgroundColor='rgb(234, 231, 231)';
  


  });
  document.getElementById('drawplgn').addEventListener('click',function(){
    if (draw2!=='none'||draw3!='none'){
      map.removeInteraction(draw2);
      map.removeInteraction(draw3);
     };
        
      map.addInteraction(draw4)
      document.getElementById('drawpnt').style.backgroundColor='rgb(234, 231, 231)';
      document.getElementById('drawline').style.backgroundColor='rgb(234, 231, 231)';
      document.getElementById('drawplgn').style.backgroundColor='yellow';
    

    });
  


///drawfeature()
//const clear = document.getElementById('clear');
//clear.addEventListener('click', function () {
 // source.clear(true);
//});

document.getElementById('Refresh').addEventListener('click', function () {
source.clear(true);
});

/**
 * Handle change event.
 */
//typeSelect.onchange = function () {
  //map.removeInteraction(draw);
  //addInteraction();
//};
//document.getElementById('undo').addEventListener('click', function () {
  //draw.removeLastPoint();
//});



///////////////////////////
//map.SetLayers(vectord30);
const raster1 = new LayerGroup({
  layers:[  new TileLayer({
  source: new BingMaps({
    key: 'Ak_BhUnNAigKZkF64lHRFwDeBR8KZpEeokYgA3cTNHmOu8i0_dHO9AByeRhLWpQV',
    imagerySet: 'AerialWithLabelsOnDemand',})}),
    vector
  ],
  
});
const raster2=new LayerGroup({
  layers: [
    new TileLayer({
      source: new OSM(),
  

    }),
    vector
  ],
});

document.getElementById('basemap').addEventListener('click',function(){
  var x=document.getElementById('osm');
  var y=document.getElementById('bingmap');
  if (x.checked==true){
    map.setLayerGroup(raster2);
    }
  else{
    map.setLayerGroup(raster1);
    }
  });



///download menu 
const format = new KML({featureProjection: 'EPSG:4326'});
const download = document.getElementById('download');
source.on('change', function () {
  const features = source.getFeatures();
  const kmllayer = format.writeFeatures(features);
  download.href =
    'data:application/kml;charset=utf-8,' + encodeURIComponent(kmllayer);
});



map.on('singleclick',function(evnt){
  
  var coordinate=evnt.coordinate;
  
var lonn=coordinate[0];
var latt=coordinate[1];


///////
//convert lonlat to utm
var rr=[]
  rr[0]=lonn;
  rr[1]=latt;
  
  
    //console.log(rr);
    var zone3=Math.floor(rr[0]/6)+31;
    if (zone3>60){
      zone3=(zone3%60)
    }
    var upsgcod = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs";
    //console.log(zone3);
    var utm3="+proj=utm +zone="+zone3;
    var coor3=[]
    coor3=proj4(upsgcod,utm3,rr);
    let xx,yy
   
    yy=coor3[1].toFixed(2);
    xx=coor3[0].toFixed(2);
  document.getElementById('cordinateY').value=yy;
   document.getElementById('cordinatex').value=xx;
    document.getElementById('zone').value=zone3;




  
  var vdgree=Math.floor(latt);
  var vminuts=Math.floor((latt-vdgree)*60);
  var vsecound=(((latt-vdgree)*60)-vminuts)*60;
  vsecound=vsecound.toFixed(2);
  
 document.getElementById('degree').value=vdgree;
 document.getElementById('minuts').value=vminuts;
 document.getElementById('secound').value=vsecound;

 var vdgree=Math.floor(lonn);
  var vminuts=Math.floor((lonn-vdgree)*60);
  var vsecound=(((lonn-vdgree)*60)-vminuts)*60;
  vsecound=vsecound.toFixed(2);
  
 document.getElementById('degreet').value=vdgree;
 document.getElementById('minutst').value=vminuts;
 document.getElementById('secoundt').value=vsecound;
 
 
 latt=latt.toFixed(6);
 lonn=lonn.toFixed(6);
 
 document.getElementById('cordinatelat').value=latt;
 document.getElementById('cordinatelon').value=lonn ;
 document.getElementById('copyclipboard').style.backgroundColor="#f06408";

})
////geolocation
//document.getElementById('trackgps').addEventListener('click',function(){

 // document.getElementById('drawpnt').style.backgroundColor='rgb(234, 231, 231)';
 // document.getElementById('drawline').style.backgroundColor='rgb(234, 231, 231)';
 // document.getElementById('trackgps').style.backgroundColor='yellow';
 const view = new View({
  center: [0, 0],
  zoom: 2,
});
 
  
  function el(id) {
    return document.getElementById(id);
  };
  
var connt=0
  el('gpsdata').addEventListener('change', function () {
 connt++
    if ((connt%2)=='1'){
      el('gpswindow').style.display='block'


      
    
    }
    else{
      el('gpswindow').style.display='none' 
    }
  });

//////////////////////////////////
const view2 = new View({
  center: [0, 0],
  zoom: 2,
  });

const map2 = new Map({
 layers: [
    new TileLayer({
      source: new BingMaps({
        key: 'Ak_BhUnNAigKZkF64lHRFwDeBR8KZpEeokYgA3cTNHmOu8i0_dHO9AByeRhLWpQV',
       imagerySet: 'RoadOnDemand',
      }),
    }),
  ],
  target: 'map2',
  view: view2,
});

 // if ("geolocation" in navigator) {

    const geolocation = new Geolocation({
      // enableHighAccuracy must be set to true to have the heading value.
      trackingOptions: {
        enableHighAccuracy: true,
      },
      projection: view2.getProjection(),
    });


  
 
  el('track').addEventListener('change', function () {
    
      geolocation.setTracking(this.checked);  
      
      });
  
  // update the HTML page when the position changes.
  
  
  geolocation.on('change', function (){
    var coord=[];
    coord=geolocation.getPosition();
    var upsgcod='EPSG:3857'
    var lonlat3="epsg:4326";
     var coor3=proj4(upsgcod,lonlat3,coord);
    let xx,yy
   
    yy=coor3[1].toFixed(2);
    xx=coor3[0].toFixed(2);

    
    el('accuracy').value = geolocation.getAccuracy() + ' [m]';
    el('altitude').value = geolocation.getAltitude()+ ' [m]';
    el('latiiudecoord').value=xx+'[m]';
    el('longtitudecoord').value=yy+'[m]';
    el('heading').value = (geolocation.getHeading())*(180/Math.PI) + ' [deg]';
    el('speed').value = geolocation.getSpeed() + ' [m/s]';
  });
  
  // handle geolocation error.
  geolocation.on('error', function (error) {
    const info = document.getElementById('info');
    info.innerHTML = error.message;
    info.style.display = '';
  });
  
  const accuracyFeature = new Feature();
  geolocation.on('change:accuracyGeometry', function () {
    accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
    
  });
  
  //const positionFeature = new Feature();
  //positionFeature.setStyle(
   // new Style({
    //  image: new CircleStyle({
      //  radius: 6,
        //fill: new Fill({
         // color: 'red',
        //}),
        //stroke: new Stroke({
         // color: 'yellow',
         // width: 2,
        //}),
    //  }),
   // }),
  //);
  
  const positionFeature = new Feature();
  positionFeature.setStyle(
    new Style({
      image: new CircleStyle({
        radius: 6,
        fill: new Fill({
          color: '#3399CC',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 2,
        }),
      }),
    }),
  );
  
  
  
  new VectorLayer({
    map: map2,
    source: new VectorSource({
      features: [accuracyFeature],
    }),
  });


 


  
  ///////////////////
  
  
 

 
  var prvmarkerlayer='null';
  var nexcoordinates='null';
  //console.log(prvmarkerlayer);
  var n1=0;
  var coordata = []
  geolocation.on ('change:position', function () {
 n1++
    const coordinates = geolocation.getPosition();
    coordata=coordata+","+coordinates;
    positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
    
    view2.setCenter(geolocation.getPosition());
    view2.setResolution(2.388657133911758);
    
   
    
   
    if (prvmarkerlayer!=='null'){
      map2.removeLayer(prvmarkerlayer);
    };
   
    
    var iconStyle = new Style({
      image: new Icon({
        anchor: [0.1, 30],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: './data/marker.png',
      }),
    });
    var iconFeature = new Feature({
      geometry: new Point(coordinates),
      name: 'Null Island',
      population: 4000,
      rainfall: 500,
    });
    
    //markerlayer.Source.clear(true);
    
    iconFeature.setStyle(iconStyle);
   
    var vectorSource = new VectorSource({
      features: [iconFeature],
    });
    
    var markerlayer = new VectorLayer({
      source: vectorSource,
    });

  map2.addLayer(markerlayer);

  prvmarkerlayer = markerlayer;

  
  if (nexcoordinates!=='null'){
let xycoordinates=coordinates;
    //var xycoordinates = proj4(coordinates, 'EPSG:4326', 'EPSG:3857');
 // lineGeometry.setCoordinates([coordinates],[geolocation.getPosition()]);
let draw5;
draw5=new Draw({
 source: new VectorSource({
   features: new Feature({
   geometry:new LineString(xycoordinates,nexcoordinates),
   }),
  }), 
  type:'LineString',
  style:styles[value2],
});
posgeometry=new LineString(xycoordinates,nexcoordinates);

gpsfeature=new Feature(posgeometry);
VectorSource.addFeature(gpsfeature);

map2.addInteraction(draw5);

 



  }
  else
  {
    nexcoordinates=xycoordinates;
  };

//////////////////
var vectorlayers2= new VectorLayer({
  source: new VectorSource({
    feature:[feature]
  })
})
if (vectorlayers2 != undefined && vectorlayers2.length != 0) {
  var s = vectorlayers2.getSource();
  var f = s.getFeatures();
  if (f.length > 0) {
      map2.removeLayer(vectorlayers2);
      vectorlayers2 = []
  }
}


var format = new WKT();

if (n1 > 1) {
  var myStyle = new Style({
      image: new CircleStyle({
          radius: 8,
          fill: new Fill({ color: 'red' }),
          stroke: new Stroke({
              color: 'yellow',
               width: 3
          })
      })
    });

  var feature = format.readFeature(
      'LineString(' + coordata + ')');
  feature.getGeometry().transform('EPSG:4326', 'EPSG:3857');
  feature.setStyle(myStyle);
  if (vectorlayers.length != 0) {
      map2.removeLayer(vectorlayers[0])
      vectorlayers = [];
  }
vectorlayers2 = new VectorLayer({
      source: new VectorSource({
          features: [feature]
      })
  });
}

map2.addLayer(vectorlayers2);
//map.getView().fit(vectorlayers2.getSource().getExtent(), map.getSize());
vectorlayers.push(vectorlayers2);









  });
//}
//else{
  //alert(" .مرورگر شما تعیین موقعیت را پشتیبانی نمی کند لطفا با مرورگر دیگری این اپلیکشن را اجرا کنید");
//};
///////////////////////gps iin map3

  
//map.addLayer(gpsLayer);






